export default "__VITE_ASSET__d6467d00__"